// extracted by mini-css-extract-plugin
export default {"box":"manager-avatar_box__X2BtM","dragger":"manager-avatar_dragger__0bMdh","close":"manager-avatar_close__tWgts","text":"manager-avatar_text__781+o"};